import {Stack} from "@mui/material";
import {Farm} from "../../../types/domain/farm";
import React from "react";
import {FarmListItem} from "./FarmListItem";
import {useParams} from "react-router-dom";
import "./FarmList.css";
import {Field} from "../../../types/domain/field";
import {Company} from "../../../types/domain/company";

interface FarmAlert {
    cropAlerts: number;
    moistureAlerts: number;
}

interface FarmListProps {
    farms: Farm[];
    farmsAlerts: Record<string, FarmAlert>;
    companyId: string;
    fieldNameFilter: string;
    foundFieldsByFarmId: Record<string, Field[]>;
    isSearching: boolean;
    fieldCropFilter: string | undefined;
    activeFieldsFilter: boolean;
    basePath: "insights" | "map";
    parentCompany: Company | undefined;
}

export const FarmList: React.FC<FarmListProps> = ({
    farms,
    farmsAlerts,
    companyId,
    fieldNameFilter,
    foundFieldsByFarmId,
    isSearching,
    fieldCropFilter,
    activeFieldsFilter,
    basePath,
    parentCompany,
}) => {
    const {farmId, fieldId} = useParams();

    return (
        <Stack
            sx={{
                display: "flex",
                flexDirection: "column",
                overflowY: "auto",
            }}
        >
            {farms?.map((farm, index) => {
                return (
                    <FarmListItem
                        key={index}
                        farm={farm}
                        active={farmId === farm.id}
                        cropAlert={farmsAlerts[farm.id]?.cropAlerts > 0}
                        moistureAlert={farmsAlerts[farm.id]?.moistureAlerts > 0}
                        companyId={companyId}
                        fieldNameFilter={fieldNameFilter}
                        activeFieldId={fieldId}
                        foundFields={foundFieldsByFarmId[farm.id]}
                        isSearching={isSearching}
                        activeFieldsFilter={activeFieldsFilter}
                        fieldCropFilter={fieldCropFilter}
                        basePath={basePath}
                        parentCompany={parentCompany}
                    />
                );
            })}
        </Stack>
    );
};
